import {Swiper, Navigation, Pagination} from 'asteq.swiper';
import {BaseDetailSlider} from 'asteq.sliders.basedetailslider';
import {Event} from 'main.core';



export class VideoSlider extends BaseDetailSlider {
    constructor(sliderBlock, params) {
        super(sliderBlock, params);
        this.initSwipers();
        Event.EventEmitter.subscribeOnce('BX.Asteq.Catalog.Modal:close', (event) => {
            this.stopAllVideos();
        });
    }

    initSwipers() {
        this.mainSwiper = new Swiper(this.mainSwiperBlock, {
            modules: [Navigation],
            navigation: {
                prevEl: this.mainSwiperBlock.querySelector('.swiper-button-prev.swiper-video-navigation'),
                nextEl: this.mainSwiperBlock.querySelector('.swiper-button-next.swiper-video-navigation'),
            },
            on: {
                slideChange: () => this.handleSlideChange(),
            }
        });
    }

    handleSlideChange() {
        // Останавливаем видео в предыдущем слайде
        const prevSlide = this.mainSwiper.slides[this.mainSwiper.previousIndex];
        const iframe = prevSlide.querySelector('iframe');
        this.stopVideo(iframe);
    }

    stopAllVideos() {
        const iframes = this.mainSwiperBlock.querySelectorAll('iframe');
        iframes.forEach(iframe => this.stopVideo(iframe));
    }

    stopVideo(iframe) {
        if (!iframe) return;

        // Сохраняем оригинальный src
        const originalSrc = iframe.src;

        // Останавливаем видео Rutube
        iframe.src = '';
        iframe.src = originalSrc;
    }
}